/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { useEffect, memo } from 'react';
import { usePrevious } from '@jira/platform__utils-react-hooks-use-previous/src/common/utils/index.tsx';
import {
	setPreviousRouterState,
	type RouterState,
} from '@jira/platform__utils-router/src/common/utils/index.tsx';

import { RouterSubscriber } from '@atlassian/react-resource-router';

const PreviousRouterStateUpdate = ({ routerState }: { routerState: RouterState }): null => {
	const previousRouterState = usePrevious(routerState);

	useEffect(() => {
		setPreviousRouterState(previousRouterState ?? null);
	}, [previousRouterState]);

	return null;
};

const PreviousRouterStateListener: React.MemoExoticComponent<() => React.JSX.Element> = memo(
	(): React.JSX.Element => (
		<RouterSubscriber>
			{(routerState) => <PreviousRouterStateUpdate routerState={routerState} />}
		</RouterSubscriber>
	),
);

PreviousRouterStateListener.displayName = 'PreviousRouterStateListener';

export { PreviousRouterStateListener, PreviousRouterStateUpdate };
